import { render, staticRenderFns } from "./pr-recommendations-bulk-update-upload.vue?vue&type=template&id=e48c1d98&scoped=true"
import script from "./pr-recommendations-bulk-update-upload.vue?vue&type=script&lang=ts"
export * from "./pr-recommendations-bulk-update-upload.vue?vue&type=script&lang=ts"
import style0 from "./pr-recommendations-bulk-update-upload.vue?vue&type=style&index=0&id=e48c1d98&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c1d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e48c1d98')) {
      api.createRecord('e48c1d98', component.options)
    } else {
      api.reload('e48c1d98', component.options)
    }
    module.hot.accept("./pr-recommendations-bulk-update-upload.vue?vue&type=template&id=e48c1d98&scoped=true", function () {
      api.rerender('e48c1d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-management/bulk-update/pr-recommendations-bulk-update-upload.vue"
export default component.exports